<template>
    <div>
        <rkm-table
            :items="data.model.profissionaisAssinatura"
            :fields="fields.tables.profissionais"
            :filter="filter"
            sort-by="nome"
        >
            <template slot="filters">
                <rkm-row>
                    <rkm-col class="flex-grow-1">
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="filter"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-input-group-text>Buscar</rkm-input-group-text>
                            </rkm-input-group-prepend>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col class="flex-grow-0">
                        <rkm-button
                            :disabled="!filter"
                            @click="handleClearFilter"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(laboratorio)="row">
                {{ getStringUnidade(row.item) }}
            </template>

            <template v-slot:cell(actions)="{ index, item }">

                <rkm-button
                    authorize="update-cadastro-usuario"
                    color="info"
                    title="Cadastrar assinatura"
                    @click="openModal(item)"
                    small
                >
                    <rkm-icon icon="upload" />
                </rkm-button>

                <rkm-button
                    @click="$refs.Modal.open(index, item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />

        <ModalAssinatura
            ref="ModalAssinatura"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'
import ModalAssinatura from '@/components/cadastro/usuario/components/assinatura/Modal'

export default {
    components: { Modal, ModalAssinatura },
    computed: {
        fields() {

            return {
                tables: {
                    profissionais: [
                        { key: 'nome', label: 'Profissional', sortable: true },
                        { key: 'laboratorio', label: 'Laboratório - Local de atendimento', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
    },
    data: () => ({
        items: [],
        filter: null,
    }),
    methods: {
        handleDestroy(item) {

            const objId = this.data.model.profissionaisAssinatura.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.data.model.profissionaisAssinatura.splice(objId, 1)

            this.showDeleteConfirmation(`Deseja realmente excluir o(a) profissional <strong>${ item.nome }</strong>?`, destroy)
        },
        handleClearFilter() {
            this.filter = null
        },
        getStringUnidade(item) {

            return `${item.nomeFantasia} - ${item.infraestruturaNome}`
        },
        openModal(item) {

            const params = {
                id: item.usuarioId,
                nome: item.nome
            }

            this.$refs.ModalAssinatura.open(params)
        }
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>